export default "__VITE_ASSET__DPEwuT55__"